<template>
  <div v-if="!loadPage">
    <luma-datatable :url="urlC"
                    :columns="columns"
                    :model="ipaddresses_model"></luma-datatable>
  </div>
</template>

<script>
  import axios from "@/store/vue-axios"
  import {VserverIpaddresses} from "@/store/models/vserver/vserver_ipaddresses";
  import LumaDatatable from "@/components/LumaDatatable";
    export default {
        name: "luma-ip-adresses-vserver",
        props:{loadPage:Boolean},
      data:()=>({
        ipaddresses_model: VserverIpaddresses
      }),
        components:{LumaDatatable},
        computed:{
          addresses(){
            if(!VserverIpaddresses.all().length) return
            return VserverIpaddresses.all()
          },
          columns(){
            if(this.loadPage === true) {
              this.getIps()
            }
            return [
              {
                key:'id',
                column:'id',
                filter:true,
                order:true
              },
              {
                key:'address',
                column:'address',
                filter:true,
                order:true
              }
            ]
          },
          vid(){
            return this.$route.params.id
          },
          urlC(){
            return "/datacenter/vservers/"+this.vid+"/addresses"
          }
        },
        methods:{
          async getIps(){
            const x = axios.get("/datacenter/vservers/"+this.vid+"/addresses").then(res=>{
              VserverIpaddresses.insertOrUpdate({data:res.data.addresses})
            })
              .catch(err=>{console.log(err)})
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-ip-adresses-vserver.vue